<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Entity Information (Conditional display for Qualified Amended Returns) -->
@if (globalScenarioDesc === 'Qualified Amended Returns') {
<div class="entity-info">
  <h3 id="CRD_FORMS_CRUD_4">
    <span class="LayerLine1">Current Issue ID:</span>
    <span class="LayerData1">{{passgriddata[0]?.data?.STD_DESC}}</span>
  </h3>
</div>
}

<!-- Modal Body with Tabs -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    <li class="active">
      <a style="cursor: pointer;" class="btn-sm">Assign</a>
    </li>
  </ul>
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <div style="padding-left: 15px; padding-right: 30px;">
    <!-- Selected LEID Section -->
    <div class="row" style="padding-top: 15px;">
      <label>Selected LEID :</label>
      <div class="well user-well-xs well-xs pull-left" style="margin-right:5px">
        @for (data of leid_list; track $index; let i = $index) {
<div 
             style="margin:0px 5px 5px 0px" 
             class="btn-group btn-group-xs" 
             role="group" 
             aria-label="">
          <div class="btn btn-default btn-xs btn-white">{{ data.leid }} - {{ data.reporting_period }}</div>
          <div class="btn btn-danger btn-xs" (click)="removeLeid(i)"><i class="fa fa-times"></i></div>
        </div>
}
      </div>
    </div>

    <!-- Template Selection Section -->
    <div class="row">
      <div class="col-md-1" style="padding-right: 0; padding-left: 0;">
        <label> Select Template :</label>
      </div>
      <div class="col-md-3" style="padding-left: 0;">
        <select class="form-control input-sm" 
                [(ngModel)]="selectedTemplate">
          <option [ngValue]="null" disabled selected>Select Template</option>
          @for (template of template_selection; track $index) {
<option 
                  [ngValue]="template">
            {{template.value}}
          </option>
}
        </select>
      </div>
      <div class="col-md-2" style="padding-left: 0;">
        <button style="padding: 1px 8px;margin-left: 4px;" 
                type="button" 
                class="btn btn-primary cancel-trans-btn" 
                (click)="loadTemplate()">Load</button>
      </div>
    </div>

    <!-- Template Display Section -->
    <div class="row templateDisplayBlock">
      <table class="templateAssignBlock table form-inline">
        <tr class="tableHeader">
          <th style="width: 3%;"></th>
          @for (header of display_template?.tableHeaders; track $index) {
<th>{{header}}</th>
}
          <th style="padding: 0 !important;width: 26px;background-color: hsla(0, 0%, 0%, 0) !important;border: none;vertical-align: middle;">
            <i class="fa fa-plus-circle color-green" (click)="addRows()"></i>
          </th>
        </tr>
          @for (row of display_template?.dataRows; track $index; let i = $index) {
<tr>
            <td class="tableData" style="text-align: center;">
              <input type="checkbox" 
                     [(ngModel)]="row.flag" 
                     (change)="checkedRow(i, row, row.flag)"/>
            </td>
            @for (key of getRowKeys(row); track $index) {
<td class="tableData" 
               >
              
              <!-- Address Line 1 & 2 -->
              @if (key === 'ADDRESS_LINE_1' || key === 'ADDRESS_LINE_2') {
<input type="text" 
                     
                     [(ngModel)]="row[key]" 
                     class="form-control input-sm" 
                     maxlength="35">
}

              <!-- City -->
              @if (key === 'CITY') {
<input type="text" 
                     
                     [(ngModel)]="row[key]" 
                     class="form-control input-sm" 
                     maxlength="50">
}

              <!-- ZIP -->
              @if (key === 'ZIP') {
<input type="text" 
                     
                     [(ngModel)]="row[key]" 
                     class="form-control input-sm" 
                     maxlength="16">
}

              <!-- Phone Number -->
              @if (key === 'PHONE_NO') {
<input type="number" 
                     
                     [(ngModel)]="row[key]" 
                     class="form-control input-sm"
                     (keydown)="$event.keyCode === 69 || $event.keyCode === 189 || $event.keyCode === 187 || $event.keyCode === 190 ? $event.preventDefault() : true">
}

              <!-- Date Picker -->
              @if (key === 'DATE') {
<div class="input-group date-picker-group" 
                   
                   style="margin-bottom: 0px; width: 100%;">
                <input type="date" 
                       placeholder="MM/dd/yyyy" 
                       class="form-control input-sm" 
                       [ngModel]="row[key] | date:'yyyy-MM-dd'" 
                       (ngModelChange)="onDateChange(row, key, $event)">
              </div>
}

              <!-- Self Employed Dropdown -->
              @if (key === 'SELF_EMPLOYED') {
<select 
                      class="form-control input-sm" 
                      [(ngModel)]="row[key]" 
                      style="width:100%">
                <option value="" disabled>Select</option>
                @for (option of selfEmployed; track $index) {
<option [value]="option.name">
                  {{option.name}}
                </option>
}
              </select>
}

              <!-- Country Dropdown -->
              @if (key === 'COUNTRY') {
<div class="input-dropdown">
                <select class="form-control input-sm" 
                        [ngModel]="getSelectedCountryId(row[key])" 
                        (ngModelChange)="onCountrySelect(i, row, $event); onCountrySelection(row.TEMPLATE_DATA_KEY)" 
                        style="width:100%;">
                  @for (country of allCountries; track $index) {
<option [value]="country.id">
                    {{country.label}}
                  </option>
}
                </select>
              </div>
}

              <!-- State Dropdown (for US) -->
              @if (key === 'STATE' && row.COUNTRY && row.COUNTRY[0]?.id === 'US') {
<div 
                   class="input-dropdown">
                <select class="form-control input-sm" 
                        [ngModel]="getSelectedStateId(row[key])" 
                        (ngModelChange)="onStateSelect(row, $event)" 
                        (click)="onCountrySelection(row.TEMPLATE_DATA_KEY)" 
                        style="width:100%;">
                  <option value="" disabled selected>Select</option>
                  @for (state of allUSStates; track $index) {
<option [value]="state.id">
                    {{state.label}}
                  </option>
}
                </select>
              </div>
}

              <!-- State Text Input (for non-US) -->
              @if (key === 'STATE' && row.COUNTRY && row.COUNTRY[0]?.id !== 'US') {
<input type="text" 
                     
                     [(ngModel)]="row[key]" 
                     class="form-control input-sm" 
                     maxlength="50">
}

              <!-- Other Fields -->
              @if (key !== 'DATE' && key !== 'ADDRESS_LINE_1' && key !== 'ADDRESS_LINE_2' && key !== 'CITY' && key !== 'ZIP' && key !== 'SELF_EMPLOYED' && key !== 'COUNTRY' && key !== 'STATE' && key !== 'PHONE_NO') {
<input type="text" 
                     
                     [(ngModel)]="row[key]" 
                     class="form-control input-sm">
}
            </td>
}
            <td class="tableData" style="text-align: center;border: hsl(36, 100%, 84%);vertical-align: middle;">
              <i class="fa fa-minus-circle color-red" (click)="display_template.dataRows.splice(i, 1)"></i>
            </td>
          </tr>
}
      </table>
    </div>
    </div>
  </div>
}
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" 
          type="button" 
          (click)="save()" 
          [disabled]="saveBtn">
    Save and Proceed <span>@if (saveloader) {
<i class="fa fa-spinner fa-pulse"></i>
}</span>
  </button>
  <button class="btn btn-danger-outline btn-sm" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="btn btn-warning btn-sm" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
